import { SEOContentFAQ } from "../../../../components/seo/SEOContentFAQ";
import { SEOImage } from "../../../../components/seo/SEOImage";

export const OratoriaVideoES = () => (
    <div className="text-slate-300">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 text-center">
            Como Hablar con Confianza y Conectar con tu Audiencia
        </h2>

        <p className="mb-8 text-lg text-center max-w-3xl mx-auto">
            La luz roja de la cámara se enciende y, de repente, tu mente se queda en blanco. Hablarle a una lente de cristal no es natural y puede intimidar incluso a los comunicadores más experimentados. La buena noticia es que la oratoria para vídeo no es un don, sino una habilidad que se puede desarrollar. Con las técnicas y herramientas adecuadas, puedes transformar tu ansiedad en autenticidad. Si aún no tienes una herramienta, <a href="/es/alternativas-teleprompter" className="text-purple-400 hover:text-purple-300 underline">mira la mejor alternativa gratuita a Teleprompter Pro aquí</a>.
        </p>

        <SEOImage
            slug="dicas-oratoria-video"
            src="public-speaking-video-confident-youtuber.webp"
            alt="YouTuber confiado grabando con teleprompter"
            caption="La oratoria magnética nace de la seguridad; herramientas como el teleprompter liberan tu carisma natural."
            width={1200}
            height={675}
            priority={true}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            <div className="bg-slate-900 p-6 rounded-lg border border-slate-800">
                <h3 className="font-bold text-white text-xl mb-3">1. El Contacto Visual es Conexión</h3>
                <p className="text-sm">
                    En una conversación, miramos a los ojos. En un vídeo, los ojos de tu audiencia son la lente de la cámara. El error más común es mirar tu propia imagen en la pantalla. Esto rompe la conexión al instante. Tu mirada debe ser fija y directa a la lente.
                </p>
                <div className="bg-slate-900 p-3 rounded-md mt-4 border-l-4 border-purple-500">
                    <p className="text-sm font-semibold text-white">La Solución: Ventana Redimensionable</p>
                    <p className="text-xs text-slate-400">
                        La ventana redimensionable de <strong>PromptNinja</strong> te permite colocar el texto exactamente sobre el área de tu cámara (en Zoom o escritorio). Esto mantiene tus ojos alineados con la lente de forma natural mientras lees.
                    </p>
                </div>
            </div>

            <div className="bg-slate-900 p-6 rounded-lg border border-slate-800">
                <h3 className="font-bold text-white text-xl mb-3">2. El Fin de las Muletillas</h3>
                <p className="text-sm">
                    "Eeeh...", "o sea...", "¿sabes?". Estos rellenos surgen cuando el cerebro busca la siguiente palabra. Minan tu credibilidad y distraen al espectador. La fluidez verbal demuestra autoridad en el tema.
                </p>
                <div className="bg-slate-900 p-3 rounded-md mt-4 border-l-4 border-purple-500">
                    <p className="text-sm font-semibold text-white">La Solución: Guion Guiado</p>
                    <p className="text-xs text-slate-400">
                        Con el guion desplazándose suavemente por la pantalla, tu cerebro no necesita "cazar" palabras. <strong>PromptNinja</strong> asegura que tu mensaje se entregue de forma limpia y profesional.
                    </p>
                </div>
            </div>

            <div className="bg-slate-900 p-6 rounded-lg border border-slate-800">
                <h3 className="font-bold text-white text-xl mb-3">3. La Regla de Energía +10%</h3>
                <p className="text-sm">
                    La cámara tiende a "aplanar" tu energía. Lo que parece normal en persona puede parecer monótono en vídeo. Proyecta tu voz, gesticula y sonríe un poco más de lo normal. Piensa en elevar tu energía entre un 10 y un 20%.
                </p>
                <div className="bg-slate-900 p-3 rounded-md mt-4 border-l-4 border-purple-500">
                    <p className="text-sm font-semibold text-white">La Solución: Foco en la Actuación</p>
                    <p className="text-xs text-slate-400">
                        Al liberar tu mente de la tarea de memorizar, puedes concentrarte al 100% en tu entrega, energía y lenguaje corporal. El teleprompter se encarga del texto.
                    </p>
                </div>
            </div>

            <div className="bg-slate-900 p-6 rounded-lg border border-slate-800">
                <h3 className="font-bold text-white text-xl mb-3">4. El Poder de la Pausa</h3>
                <p className="text-sm">
                    El silencio es tan importante como el habla. Las pausas estratégicas dan tiempo a la audiencia para absorber la información y crean anticipación. No tengas prisa. Usa las comas y los puntos de tu guion como momentos para respirar y dejar que el mensaje brille.
                </p>
            </div>

            <div className="bg-slate-900 p-6 rounded-lg border border-slate-800">
                <h3 className="font-bold text-white text-xl mb-3">5. Lenguaje Corporal Abierto</h3>
                <p className="text-sm">
                    Cruzar los brazos o encoger los hombros transmite inseguridad. Mantén los hombros relajados y abiertos. Usa las manos para enfatizar puntos importantes, pero evita movimientos repetitivos que distraigan. Ocupar espacio transmite confianza.
                </p>
            </div>
        </div>

        {/* CTA Contextualizado */}
        <div className="bg-indigo-900/40 p-8 rounded-xl my-12 border-l-4 border-indigo-500 shadow-xl relative overflow-hidden group hover:bg-indigo-900/50 transition duration-300">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-indigo-500 rounded-full blur-3xl opacity-20 group-hover:opacity-30 transition duration-500"></div>

            <h3 className="font-bold text-2xl text-white mb-3 relative z-10">¡Deja de depender de la memoria!</h3>
            <p className="text-slate-200 mb-6 relative z-10 max-w-2xl">
                Las técnicas de oratoria funcionan, pero si aún te sientes inseguro o pierdes el hilo, el mejor consejo es: <strong>Usa PromptNinja</strong>. Te permite leer con fluidez, eliminando la ansiedad, los blancos y la necesidad de memorizar guiones.
            </p>

            <a
                href="https://promptninja.solutionkit.com.br/?lang=es/#app"
                className="inline-block relative z-10 bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-500 hover:to-blue-500 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-indigo-500/25 transform hover:-translate-y-1 transition duration-200"
            >
                Practicar con Teleprompter GRATIS
            </a>
        </div>

        <div className="bg-slate-900 p-8 rounded-2xl border border-slate-800 shadow-lg mt-12">
            <h3 className="text-3xl font-bold text-white mb-6 text-center">El Enemigo Silencioso: Carga Cognitiva</h3>
            <p className="text-center max-w-2xl mx-auto">
                Intentar recordar un guion, controlar la cámara, pensar en la iluminación y además parecer natural es una receta para el desastre. Esto se llama alta carga cognitiva. Ocurre cuando tu cerebro está sobrecargado con múltiples tareas complejas.
            </p>
            <p className="text-center max-w-2xl mx-auto mt-4">
                La herramienta más eficaz para reducir esta carga es el teleprompter. Elimina la tarea más pesada –la memorización– permitiendo que tu mente se concentre en lo que realmente importa: <strong>conectar con tu audiencia.</strong>
            </p>
        </div>

        <h3 className="text-3xl font-bold text-white mt-12 mb-6 text-center">Cómo PromptNinja Revoluciona tu Oratoria</h3>
        <ul className="space-y-4 max-w-2xl mx-auto">
            <li className="bg-slate-800 p-4 rounded-lg border border-slate-700">
                <h3 className="font-bold text-white">Control Total en la Palma de tu Mano</h3>
                <p className="text-sm text-slate-400">Usa tu smartphone como un control remoto seguro a través de un código QR. Pausa, acelera o ralentiza el texto para que coincida con tu ritmo natural al hablar. Se acabó el sonar como un robot leyendo un texto.</p>
            </li>
            <li className="bg-slate-800 p-4 rounded-lg border border-slate-700">
                <h3 className="font-bold text-white">Funciona en Cualquier Dispositivo, Sin Instalar Nada</h3>
                <p className="text-sm text-slate-400">Abre PromptNinja en el navegador de tu PC, tablet o móvil. Sin descargas, sin complicaciones. Graba donde y como quieras.</p>
            </li>
            <li className="bg-slate-800 p-4 rounded-lg border border-slate-700">
                <h3 className="font-bold text-white">Hablas y el Texto te Sigue (Función Pro)</h3>
                <p className="text-sm text-slate-400">Con nuestro reconhecimento de voz, el guion avanza mientras hablas. Es la experiencia de teleprompter más fluida e profesional que existe.</p>
            </li>
        </ul>

        <SEOImage
            slug="dicas-oratoria-video"
            src="public-speaking-executive-video-conference.webp"
            alt="Ejecutivo usando un teleprompter en una videoconferencia"
            caption="El uso de un teleprompter en videoconferencias corporativas garantiza autoridad, claridad y contacto visual constante."
            width={1200}
            height={675}
        />

        <div className="text-center mt-12">
            <a
                href="https://promptninja.solutionkit.com.br"
                className="inline-block bg-gradient-to-r from-blue-500 to-purple-500 font-bold py-3 px-8 mx-auto rounded-full transition hover:brightness-110"
                style={{ color: 'white' }}
            >
                Desbloquea tu Confianza. ¡Prueba PromptNinja Gratis!
            </a>
            <p className="text-slate-400 mt-4 text-sm">La herramienta que separa a los aficionados de los profesionales.</p>
        </div>

        <div className="mt-16">
            <SEOContentFAQ
                title="Preguntas Frecuentes (FAQ)"
                items={[
                    {
                        question: "¿Usar un teleprompter no me hará parecer un robot?",
                        answer: "Al contrario. Un buen teleprompter, combinado con el control remoto P2P de PromptNinja, te permite ajustar la velocidad en tiempo real, coincidiendo con tu ritmo natural al hablar. La apariencia robótica proviene de intentar memorizar y recitar, no de leer con fluidez con la herramienta adecuada."
                    },
                    {
                        question: "¿Necesito equipo caro para usar PromptNinja?",
                        answer: "No. Solo necesitas dos dispositivos con acceso a un navegador: uno para la pantalla (como un portátil o una tablet) y otro para el control (tu móvil). No se requiere hardware adicional."
                    },
                    {
                        question: "¿Es difícil de configurar?",
                        answer: "Tarda menos de 30 segundos. Accede a la web, pega tu guion, haz clic en \"iniciar\" y escanea el código QR con tu móvil. Es la forma más rápida y sencilla de tener un sistema de teleprompter profesional."
                    }
                ]}
            />
        </div>
    </div>
);
